import React, { Component } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./style.css";
import { toast } from "react-toastify";
import service from "../../services/service";
import LoadingOverlay from "../../components/loading/loading";
import authService from "../../services/authService";

class Hero extends Component {
    constructor(props) {
        super(props);
        this.state = {
            information: [],
            loading: false,
            randomHotel: [],
            hotelSets: [],
            opinions: [],
            showModal: false,
            showOptionsModal: false,
            selectedOption: "",
            commissionRate: 0,
            totalBookings: 0,
            currentHotelIndex: 0,
            success: false,
        };
    }

    componentDidMount = async () => {
        this.setState({ loading: true });

        try {
            await Promise.all([
                this.getInformation(),
                this.getUserDetailsByID(),
                this.getOpinions()
            ]);
        } catch (error) {
            toast.error(error.message);
        } finally {
            this.setState({ loading: false });
        }
    };

    getUserDetailsByID = async () => {
        try {
            const isLoggedIn = sessionStorage.getItem("isLoggedIn") === "true";
            const userId = sessionStorage.getItem("userId");
            if (!isLoggedIn || !userId) return;

            // Run both API calls concurrently
            const [userDetail, hotelResponse] = await Promise.all([
                authService.getUserDetailsById(userId),
                service.view(`hotel-sequence/user/${userId}`)
            ]);

            if (!userDetail?.success) return;
            if (!hotelResponse?.success) return;

            this.setState({
                commissionRate: userDetail.user.commissionRate,
                totalBookings: userDetail.totalBookings,
                hotelSets: hotelResponse.data.hotelSets,
                currentHotelIndex: hotelResponse.data.currentHotelIndex,
            });
        } catch (error) {
            toast.error(error.message);
        }
    };

    getInformation = async () => {
        try {
            const response = await service.view("information");
            if (!response?.success) {
                toast.error(response.message);
                return;
            }

            this.setState({ information: response.information });
        } catch (error) {
            toast.error(error.message);
        }
    };

    getOpinions = async () => {
        try {
            const response = await service.view("opinions");
            if (!response?.success) {
                toast.error(response.message);
                return;
            }

            const opinions = response.opinions;
            this.setState({
                opinions,
                selectedOption: opinions.length ? opinions[0]._id : ""
            });
        } catch (error) {
            toast.error(error.message);
        }
    };

    handleBookNow = async () => {
        if (sessionStorage.getItem("isLoggedIn") !== "true") {
            return toast.error("Please login to continue");
        }

        this.setState({ loading: true });

        try {
            const { hotelSets, currentHotelIndex } = this.state;

            // Ensure hotels are available
            if (!hotelSets?.length) {
                return toast.error("No available hotels to book.");
            }

            if (currentHotelIndex >=30) {
                return toast.error("You have reached the maximum number of bookings (30).");
            }

            // Select the current hotel in sequence
            const nextHotel = hotelSets[currentHotelIndex];
            this.setState({
                randomHotel: nextHotel,
                showModal: true,
            });
        } catch (error) {
            toast.error(error.message);
        } finally {
            this.setState({ loading: false });
        }
    };

    handleConfirmBooking = () => {
        this.setState({ showModal: false, showOptionsModal: true });
    };

    handleOptionChange = (event) => {
        this.setState({ selectedOption: event.target.value });
    };

    handleSubmitOptions = async () => {
        if (sessionStorage.getItem("isLoggedIn") !== "true") {
            return toast.error("Please login to continue");
        }

        if (!this.state.selectedOption) {
            return toast.error("Please select an opinion before proceeding.");
        }

        const { selectedOption, randomHotel, commissionRate, currentHotelIndex } = this.state;
        const commission = Number((randomHotel.pricePerNight * commissionRate / 100).toFixed(2));

        const updatedFormData = {
            hotel_id: randomHotel._id,
            user_id: sessionStorage.getItem("userId"),
            opinion_id: selectedOption,
            pricePerNight: randomHotel.pricePerNight,
            commission,
            commissionRate,
            currentHotelIndex: currentHotelIndex + 1
        };

        this.setState({ loading: true });

        try {
            const { success, message } = await service.save(updatedFormData, "bookings/book-hotel-review") || {};
            toast[success ? "success" : "error"](message);
            if (success) {
                this.setState({ success: true }, () => {
                    this.props.onSuccess(); // Notify HomePage to refresh
                });
            }
        } catch (error) {
            toast.error(error.message);
        } finally {
            this.setState({ showOptionsModal: false, loading: false });
        }
    };

    render() {
        const { information, loading, showModal, randomHotel, showOptionsModal, selectedOption, opinions, totalBookings } = this.state;
        const settings = {
            dots: true,
            arrows: true,
            speed: 1200,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2500,
            fade: true,
        };

        return (
            <section className={`hero ${this.props.heroClass}`}>
                {loading && <LoadingOverlay />}
                <div className="hero-slider">
                    <Slider {...settings}>
                        <div className="slide">
                            <div className="slide-inner" style={{ backgroundImage: `url(${this.props.heroImg1})` }}>
                                <div className="container">
                                    <div className="row">
                                        <div className="col col-lg-8 col-md-12 col-12 slide-caption">
                                            <div className="slide-title">
                                                <h2>{information?.slider1Title}</h2>
                                            </div>
                                            {
                                                sessionStorage.getItem("isLoggedIn") === 'true' &&
                                                <div className="slide-subtitle">
                                                    <p>Booking Count: {totalBookings}</p>
                                                </div>
                                            }
                                            <div className="btns">
                                                <button onClick={this.handleBookNow} className="theme-btn">
                                                    Book Now
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Slider>
                </div>

                {showModal && (
                    <div className="modal-overlay" onClick={() => this.setState({ showModal: false })}>
                        <div className="modal-container" onClick={(e) => e.stopPropagation()}>
                            <button className="modal-close" onClick={() => this.setState({ showModal: false })}>
                                ×
                            </button>
                            <div className="modal-header">
                                <h2>Order Details</h2>
                            </div>
                            <div className="modal-body">
                                <div className="price-item">
                                    <span>Booking Count</span>
                                    <span className="price">{totalBookings}</span>
                                </div>
                                <div className="price-item">
                                    <span>Hotel</span>
                                    <span className="price">{randomHotel.name}</span>
                                </div>
                                <div className="price-item">
                                    <span>Price</span>
                                    <span className="price">₹ {randomHotel.pricePerNight?.toFixed(2)}</span>
                                </div>
                                <div className="price-item">
                                    <span>Commission</span>
                                    <span className="price">
                                        ₹ {randomHotel.pricePerNight && this.state.commissionRate
                                            ? (randomHotel.pricePerNight * this.state.commissionRate / 100).toFixed(2)
                                            : "N/A"}
                                    </span>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button
                                    className="btn-secondary"
                                    onClick={() => this.setState({ showModal: false })}
                                >
                                    Cancel
                                </button>
                                <button
                                    className="btn-primary"
                                    onClick={this.handleConfirmBooking}
                                >
                                    Confirm Booking
                                </button>
                            </div>
                        </div>
                    </div>
                )}

                {showOptionsModal && (
                    <div className="modal-overlay" onClick={() => this.setState({ showOptionsModal: false })}>
                        <div className="modal-container" onClick={(e) => e.stopPropagation()}>
                            <button className="modal-close" onClick={() => this.setState({ showOptionsModal: false })}>
                                ×
                            </button>
                            <div className="modal-header" style={{ color: "#317afa" }}>
                                <h2>Share Your Opinion</h2>
                            </div>
                            <div className="modal-body">
                                <label>Please select at least one</label>
                                {opinions.length > 0 ? (
                                    opinions.map((option, index) => (
                                        <div key={index}>
                                            <label>
                                                <input
                                                    type="radio"
                                                    name="option"
                                                    value={option._id}
                                                    checked={selectedOption === option._id}
                                                    onChange={this.handleOptionChange}
                                                />
                                                &nbsp;{option.opinions.join(", ")}
                                            </label>
                                        </div>
                                    ))
                                ) : (
                                    <p>No opinions available.</p>
                                )}
                            </div>
                            <div className="modal-footer">
                                <button
                                    className="btn-secondary"
                                    onClick={() => this.setState({ showOptionsModal: false })}
                                >
                                    Cancel
                                </button>
                                <button className="btn-primary" onClick={this.handleSubmitOptions}>
                                    Submit
                                </button>
                            </div>
                        </div>
                    </div>
                )}

            </section>
        );
    }
}

export default Hero;
